import { all } from "redux-saga/effects";

import { watchAvailabilities } from "./doctorAvailabilitiesHandler";
import { watchNotifications } from "./notificationSaga";
import { watchSession } from "./sessionHandler";
import { watchGetSpecialties } from "./specialtiesHandler";

export function* rootSaga() {
  // eslint-disable-next-line redux-saga/no-unhandled-errors
  yield all([
    watchSession(),
    watchAvailabilities(),
    watchNotifications(),
    watchGetSpecialties(),
  ]);
}
